<template>
  <div>
    <AppNotification
      :messageId="notificationId"
      :message="notificationMessage"
      :icon="notificationIcon"
      :color="notificationColor"
      :timeOut="notificationTimeOut"
    />
    <AppHeader
      :pages="pages"
      :currentPage.sync="currentPage"
      :navItems="navItems"
      :isLoading="isLoading"
    />
    <keep-alive>
      <component
        v-if="currentPage"
        :is="currentPage.component"
        :breadCrumbs="breadCrumbs"
        :assetId="assetId"
        :activityId="activityId"
        :attachmentId="attachmentId"
        @onClickViewEquipmentFromAssetList="
          (val) => onClickViewEquipmentFromAssetList(val)
        "
        @onClickViewEquipmentFromAttachmentDetail="
          (val) => onClickViewEquipmentFromAttachmentDetail(val)
        "
        @onClickViewEquipmentFromActivityDetail="
          (val) => onClickViewEquipmentFromActivityDetail(val)
        "
        @onClickViewActivityFromAssetDetail="
          (val) => onClickViewActivityFromAssetDetail(val)
        "
        @onClickViewActivityFromAttachmentDetail="
          (val) => onClickViewActivityFromAttachmentDetail(val)
        "
        @onClickViewAttachmentFromAssetDetail="
          (val) => onClickViewAttachmentFromAssetDetail(val)
        "
        @onClickViewAttachmentFromActivityDetail="
          (val) => onClickViewAttachmentFromActivityDetail(val)
        "
        @onClickBreadcrumb="(val) => onClickBreadcrumb(val)"
        @notify="
          ({ message, icon, color, timeOut } = {}) => {
            notificationMessage = message;
            notificationIcon = icon;
            notificationColor = color;
            notificationTimeOut = timeOut;
            notificationId++;
          }
        "
        @isLoadingChange="(isLoadingUpdate) => (isLoading = isLoadingUpdate)"
      />
    </keep-alive>
  </div>
</template>

<script>
import pages from './config/pages'
import AppHeader from './AppHeader'
import AppNotification from './AppNotification'

export default {
  components: {
    AppHeader,
    AppNotification,
  },
  props: {
    service: Object,
  },
  data: () => ({
    isLoading: false,
    currentPage: pages.equipment,
    pages: pages,
    assetId: -1,
    activityId: -1,
    attachmentId: -1,
    notificationMessage: '',
    notificationIcon: '',
    notificationColor: '',
    notificationTimeOut: null,
    notificationId: 0,
    breadCrumbs: [],
  }),
  computed: {
    navItems() {
      return [
        {
          name: 'Equipment',
          page: this.pages.equipment,
        },
        {
          name: 'Locations',
          page: this.pages.equipmentLocations,
        },
        {
          name: 'Statuses',
          page: this.pages.equipmentStatuses,
        },
        {
          name: 'Activity Types',
          page: this.pages.equipmentActivityTypes,
        },
        {
          name: 'Models',
          page: this.pages.equipmentModels,
        },
        {
          name: 'Manufacturers',
          page: this.pages.equipmentManufacturers,
        },
        {
          name: 'Categories',
          page: this.pages.equipmentCategories,
        },
        {
          name: 'Clients',
          page: this.pages.equipmentClients,
        },
        {
          name: 'Users',
          page: this.pages.equipmentUsers,
        },
      ]
    },
  },
  methods: {
    onClickBreadcrumb(crumb) {
      this.breadCrumbs.splice(this.breadCrumbs.indexOf(crumb))
      this.assetId = crumb.assetId
      this.activityId = crumb.activityId
      this.attachmentId = crumb.attachmentId
      this.currentPage = pages[crumb.page]
    },
    onClickViewEquipmentFromAssetList({ assetId, breadCrumbTitle } = {}) {
      this.breadCrumbs.splice(0)
      this.assetId = assetId
      this.breadCrumbs.push({
        page: pages.equipment.name,
        text: breadCrumbTitle,
      })
      this.currentPage = pages.equipmentDetail
    },
    onClickViewEquipmentFromActivityDetail({ assetId, breadCrumbTitle } = {}) {
      let index = this.breadCrumbs
        .map((crumb) => crumb.assetId)
        .indexOf(assetId)
      if (index > -1) {
        this.breadCrumbs.splice(index)
      } else {
        this.assetId = assetId
        this.breadCrumbs.push({
          page: pages.activityDetail.name,
          activityId: this.activityId,
          text: breadCrumbTitle,
        })
      }
      this.currentPage = pages.equipmentDetail
    },
    onClickViewEquipmentFromAttachmentDetail({
      assetId,
      breadCrumbTitle,
    } = {}) {
      let index = this.breadCrumbs
        .map((crumb) => crumb.assetId)
        .indexOf(assetId)
      if (index > -1) {
        this.breadCrumbs.splice(index)
      } else {
        this.assetId = assetId
        this.breadCrumbs.push({
          page: pages.attachmentDetail.name,
          attachmentId: this.attachmentId,
          text: breadCrumbTitle,
        })
      }
      this.currentPage = pages.equipmentDetail
    },
    onClickViewActivityFromAssetDetail({ activityId, breadCrumbTitle } = {}) {
      let index = this.breadCrumbs
        .map((crumb) => crumb.activityId)
        .indexOf(activityId)
      if (index > -1) {
        this.breadCrumbs.splice(index)
      } else {
        this.activityId = activityId
        this.breadCrumbs.push({
          page: pages.equipmentDetail.name,
          assetId: this.assetId,
          text: breadCrumbTitle,
        })
      }
      this.currentPage = pages.activityDetail
    },
    onClickViewActivityFromAttachmentDetail({
      activityId,
      breadCrumbTitle,
    } = {}) {
      let index = this.breadCrumbs
        .map((crumb) => crumb.activityId)
        .indexOf(activityId)
      if (index > -1) {
        this.breadCrumbs.splice(index)
      } else {
        this.activityId = activityId
        this.breadCrumbs.push({
          page: pages.attachmentDetail.name,
          attachmentId: this.attachmentId,
          text: breadCrumbTitle,
        })
      }
      this.currentPage = pages.activityDetail
    },
    onClickViewAttachmentFromAssetDetail({
      attachmentId,
      breadCrumbTitle,
    } = {}) {
      let index = this.breadCrumbs
        .map((crumb) => crumb.attachmentId)
        .indexOf(attachmentId)
      if (index > -1) {
        this.breadCrumbs.splice(index)
      } else {
        this.attachmentId = attachmentId
        this.breadCrumbs.push({
          page: pages.equipmentDetail.name,
          assetId: this.assetId,
          text: breadCrumbTitle,
        })
      }
      this.currentPage = pages.attachmentDetail
    },
    onClickViewAttachmentFromActivityDetail({
      attachmentId,
      breadCrumbTitle,
    } = {}) {
      let index = this.breadCrumbs
        .map((crumb) => crumb.attachmentId)
        .indexOf(attachmentId)
      if (index > -1) {
        this.breadCrumbs.splice(index)
      } else {
        this.attachmentId = attachmentId
        this.breadCrumbs.push({
          page: pages.activityDetail.name,
          activityId: this.activityId,
          text: breadCrumbTitle,
        })
      }
      this.currentPage = pages.attachmentDetail
    },
  },
}
</script>
